export default __webpack_public_path__ + "static/media/File.3a9a976b.svg";